import { useSelector } from "react-redux";
import { IDCard } from "../../components";
import { RootState } from "../../store";
import { Attender } from "../../types/attenderType";

interface Props {
  attender?: Attender;
}

export default function EscortIDCardContainer({ attender }: Props) {
  const school = useSelector((state: RootState) => state.access.schoolBranch);

  return (
    <div className="grid md:grid-cols-2 gap-20 print-grid">
      <IDCard
        side="front"
        logo={school?.schoolBranchIcon}
        roleLabel="Escort"
        roleGradient="linear-gradient(270deg, #FFF 0%, #EAF4FF 21.63%, #60A5FA 40.38%, #2563EB 59.13%, #1E3A8A 100%)"
        textColorClass="text-primary-700"
        name={attender?.fullName}
        phone={attender?.mobileNo}
        image={attender?.profileUrl}
      />

      <IDCard
        side="back"
        logo={school?.schoolBranchIcon}
        roleLabel="Escort"
        textColorClass="text-primary-700"
        email={attender?.email}
        footerEmail={school?.emailAddress}
        QRCode={""}
        schoolName={school?.schoolBranchName}
      />
    </div>
  );
}
